module.exports = __webpack_public_path__ + "media/src/fonts/uni-neue/uni-neue-300-book-58ea29523996a0bd29546aa007589341.woff2";